import * as React from 'react';
import { numberWithCommas, numberFormat } from '../../Common/Helpers';
import MapContainer from '../../Common/MapContainer';
import { EmployeeReportState } from '../../../interface/EmployeeReportInterface';
import { UserState } from '../../../interface/MyInterfaces';
import renderHTML from 'react-render-html';
import ReactPaginate from 'react-paginate';

//track use visit
import { withUserActionTracker } from './../../../sharedUtilities/UserActionTracker';

class GeographicDestinationsTab extends React.Component<EmployeeReportState & UserState, EmployeeReportState> {
    constructor(props) {
        super(props);
        this.state = {
            currentPage: 0
        };
    }

    bullets() {
        if (this.props.EmployeeReport_Tab1 && this.props.EmployeeReport_Tab1.bullets != "") {
            return (renderHTML(this.props.EmployeeReport_Tab1.bullets))
        }
        return <div>loading <i className="fa fa-spinner"></i></div>
    }

    top_destinations(currentPage) {
        if (this.props.EmployeeReport_Tab1 && this.props.EmployeeReport_Tab1.destination_counts !== undefined) {
            return this.props.EmployeeReport_Tab1.destination_counts.map((x, index) => {
                if (index>=currentPage * 10 && index < (1 + currentPage)*10)
                    return <li>{x.label} ({x.value})</li>
            })
        }
        return <div>loading <i className="fa fa-spinner"></i></div>
    }
    in_state_count() {
        if (this.props.EmployeeProfileInfo && (this.props.EmployeeProfileInfo.state_fips == 99 || this.props.EmployeeProfileInfo.state == "All states")){
            //non state level
            return;
        }
        if (this.props.EmployeeReport_Tab1 && this.props.EmployeeReport_Tab1.in_state_count !== undefined) {
            return <span className="rightAlign">{renderHTML(this.props.EmployeeReport_Tab1.in_state_count)}</span>;
        }
        return <div>loading <i className="fa fa-spinner"></i></div>
    }
    loadMap() {
        if (this.props.EmployeeProfile1 !== undefined && this.props.EmployeeProfileInfo !== undefined) {
            return <MapContainer isEmployee={true} state_fips={this.props.EmployeeProfileInfo.state_fips} mapData={this.props.EmployeeProfile1} />
        } else {
            return <div>loading <i className="fa fa-spinner"></i></div>
        }

    }
    
    handlePageClick = (data) => {
        const currentPage = data.selected;
        this.setState({ currentPage });
    }
    public render() {
        const census_logo = require('../../../images/censusLogo.png');

        let logoUni;
        try {
            logoUni = require(`../../../images/univ_logos/${this.props.display_id}.png`);
        }
        catch (err) {

        }
        return <div className='tabcontents container-fluid employee_report'>

            <div className="row">
                <div className="col-md-10">
                    <h1><span>{this.props.EmployeeProfileInfo && this.props.EmployeeProfileInfo.university} Employee Profile Report</span>:</h1>
                    {this.props.display_id == "99007319" && <h2><b style={{ color: "red" }}>Synthetic data for demonstration purposes only</b></h2>}

                </div>
                <div className="report__logo">{logoUni &&
                    <img height='80px' src={String(logoUni)} alt='Logo'></img>
                }
                </div>
                <div className="col-md-12">
                <p style={{ fontSize: "18px", paddingTop: "10px" }}>
                    {this.props.agg ? `The employment patterns of research-trained university employees can be important to understanding the impacts of research funding.` : `Many universities are interested in characterizing the work of research-trained employees when those employees leave their universities.`} Do these employees work in the education sector, or in the private sector? What are their average earnings one year after leaving {this.props.agg ? `their home universities` : `the university`}, or two years, or five years? In what US states do these employees work? The Employee Profile report {this.props.agg ? `` : `for your university`} answers these questions.
                </p>
                </div>
            </div>

  
            <div className='row'>
                <div className="col-md-12 destination_bullets">
                    <h3>Geographic Destinations</h3>
                    <p style={{ fontSize: "18px" }}>The Geographic Destinations tab shows a map of the United States and a list of the top states in which{this.props.agg ? `` : ` your`} research-trained employees work after leaving {this.props.agg ? `their home universities` : `your university`}. This report is summed across cohorts and across calendar years, so that any employee moving to a given state is counted in the total for that state, regardless of the year (from {this.props.EmployeeProfileInfo && this.props.EmployeeProfileInfo.year_first_left} to 2017) that the move took place. The logarithmic scale used for the maps improves the shading of state destinations making the map more readable.</p>
                    {this.bullets()}
                    <br /><br />
                    <h3>{this.props.EmployeeProfileInfo && this.props.EmployeeProfileInfo.university} employees find employment across the U.S.</h3>
                </div>
            </div>
            <div className='row'>
                <div className="col-md-3">
                    <h5>Top employee destinations by state with employee count</h5>
                    <ul className="destination_list">
                        {this.top_destinations(this.state.currentPage)}
                        <ReactPaginate
                            previousLabel={"<<"}
                            nextLabel={">>"}
                            previousClassName={"previous"}
                            nextClassName={"next"}
                            pageCount={6}
                            pageRangeDisplayed={0}
                            marginPagesDisplayed={0}
                            breakLabel={null}
                            breakClassName={"paginate-break"}
                            onPageChange={this.handlePageClick}
                            containerClassName={"pagination"}
                            subContainerClassName={"pages pagination"}
                            activeClassName={"active"} />
                    </ul>
                </div>
                <div className="col-md-9">
                    <div className="chartcontainer">
                        {this.in_state_count()}
                        {this.loadMap()}          
                    </div>
                </div>
            </div>
            <div className='row'>
                <div className="col-md-12">
                <img src={String(census_logo)} height='60' />
                </div>
            </div>

        </div>;
    }
}

export default withUserActionTracker(GeographicDestinationsTab, "Census Supplemental Employee Profile Report","viewed Geographic Destinations Tab");